import { queryKey } from '../constants/queryClientKey';
import {
  createRole,
  deleteRole,
  getRoles,
  ParamsCreateRole,
  ParamsRole,
  ParamsUpdateRole,
  updateRole,
} from '../apis/role.api';
import { sortObjectKeys } from '@vindr/utils/helpers/common.helper';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useGetRoles(param: Parameters<typeof getRoles>[0]) {
  return useQuery([queryKey.roles, sortObjectKeys(param)], () => getRoles(param), {
    keepPreviousData: true, //? Keep data when pagination
    cacheTime: 1000 * 60 * 5, //? 5 minutes

    onError: (err) => {
      console.error('useGetRoles', err);
    },
  });
}

export function useSearchRole() {
  return useMutation(async (params: ParamsRole) => getRoles(params), {
    onError: (err) => {
      console.error('useSearchRole', err);
    },
  });
}

export function useCreateRole() {
  const queryClient = useQueryClient();

  return useMutation(async (params: ParamsCreateRole) => createRole(params), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.roles]);
    },
    onError: (err) => {
      console.error('useCreateRole', err);
    },
  });
}

/* export function useCreatePermission() {
  const queryClient = useQueryClient();

  return useMutation(async (params: ParamsCreatePermissions) => CreatePermissions(params), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.roles]);
    },

    onError: (err) => {
      console.error('useCreatePermission', err);
    },
  });
} */

export function useUpdateRole() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id, data }: { id: string; data: ParamsUpdateRole }) => updateRole(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.roles]);
      },

      onError: (err) => {
        console.error('useUpdateRoles', err);
      },
    }
  );
}

export function useDeleteRole() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => deleteRole(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.roles]);
    },

    onError: (err) => {
      console.error('useDeleteRoles', err);
    },
  });
}
